import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18View0 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillOpacity: 0.86,
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        d: "M9 6.488c1.446 0 2.618 1.125 2.618 2.512S10.446 11.512 9 11.512 6.382 10.387 6.382 9 7.554 6.488 9 6.488m0 .867c-.947 0-1.714.737-1.714 1.645S8.053 10.644 9 10.644c.946 0 1.714-.736 1.714-1.644S9.946 7.355 9 7.355"
      }), /*#__PURE__*/jsx("path", {
        d: "M9 4c2.04 0 3.915 1.47 5.544 3.644a2.24 2.24 0 0 1 0 2.711C12.914 12.53 11.039 14 9 14c-2.04 0-3.914-1.47-5.544-3.645a2.24 2.24 0 0 1 0-2.711C5.086 5.47 6.961 4 9 4m0 .867c-1.655 0-3.339 1.32-4.81 3.283a1.4 1.4 0 0 0 0 1.699c1.472 1.965 3.155 3.284 4.81 3.284s3.338-1.32 4.81-3.284a1.4 1.4 0 0 0 0-1.699C12.339 6.186 10.655 4.867 9 4.867"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18View0$1 = Svg18View0;

export { Svg18View0$1 as default };
